import { render, staticRenderFns } from "./PaymentNoteModal.vue?vue&type=template&id=08894f90&"
import script from "./PaymentNoteModal.vue?vue&type=script&lang=ts&"
export * from "./PaymentNoteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports